// FILE: src/AboutPage.js
import React, { useState, useEffect } from "react";
import { APP_VERSION, APP_BUILD_DATE } from "./version";
import { ABOUT_CHANGELOG } from "./aboutChangelog";
import { getDownloadURL, ref } from "firebase/storage";
import { storage } from "./firebase";
import Menu from "./Menu";

export default function AboutPage() {
  const [bgUrl, setBgUrl] = useState("");
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    getDownloadURL(ref(storage, "media/Brainbackground.png")).then(setBgUrl);
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        background: bgUrl
          ? `linear-gradient(rgba(24,24,40,0.77), rgba(44,16,50,0.82)), url(${bgUrl}) center center / cover no-repeat`
          : "#223b4c",
        fontFamily: "'Montserrat', 'Open Sans', Arial, sans-serif",
      }}
    >
      {/* Top Bar with Menu Button (same chrome as other pages) */}
      <div
        style={{
          width: "100%",
          padding: "14px 16px",
          background: "rgba(20,15,44,0.55)",
          display: "flex",
          alignItems: "center",
          gap: 12,
          position: "sticky",
          top: 0,
          zIndex: 999,
        }}
      >
        <button
          aria-label="Open menu"
          title="Menu"
          onClick={() => setShowMenu(true)}
          style={{
            background: "rgba(255,255,255,0.08)",
            border: "1px solid rgba(255,255,255,0.16)",
            color: "#ffe066",
            fontWeight: 900,
            borderRadius: 12,
            padding: "10px 14px",
            cursor: "pointer",
          }}
        >
          ☰ Menu
        </button>

        <div
          style={{
            marginLeft: 8,
            fontWeight: 900,
            color: "#f8faff",
          }}
        >
          About
        </div>
      </div>

      {/* Sidebar instance */}
      <Menu open={showMenu} onClose={() => setShowMenu(false)} />

      {/* Content card */}
      <div
        style={{
          background: "rgba(28,34,58,0.67)",
          padding: "44px 54px 38px 54px",
          borderRadius: "2.2em",
          boxShadow: "0 8px 36px 8px #111b, 0 1.5px 12px #2ae8",
          minWidth: 340,
          maxWidth: "90vw",
          textAlign: "center",
          fontSize: "1.19em",
          color: "#e7f1fd",
          marginTop: 38,
        }}
      >
        <div
          style={{
            fontWeight: 900,
            fontSize: "2.0em",
            marginBottom: 18,
            color: "#e2eefd",
            textShadow: "2px 2px 14px #2ae, 0 2px 12px #09f, 0 4px 16px #222c",
          }}
        >
          About Quizmaster
        </div>
        <div style={{ margin: "18px 0 0 0", color: "#b7e4ff", fontWeight: 700 }}>
          Version: <span style={{ color: "#fff" }}>{APP_VERSION}</span>
        </div>
        <div style={{ margin: "6px 0 28px 0", color: "#b7e4ff", fontWeight: 700 }}>
          Build Date: <span style={{ color: "#fff" }}>{APP_BUILD_DATE}</span>
        </div>

        <div
          style={{
            marginTop: 28,
            marginBottom: 8,
            textAlign: "left",
            maxWidth: 520,
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <div
            style={{
              fontWeight: 900,
              fontSize: "1.15em",
              color: "#e2eefd",
              marginBottom: 14,
              textAlign: "center",
            }}
          >
            Change log
          </div>
          <div
            style={{
              maxHeight: 320,
              overflowY: "auto",
              paddingRight: 8,
              fontSize: "0.92em",
              lineHeight: 1.45,
            }}
          >
            {ABOUT_CHANGELOG.map((entry) => (
              <div
                key={entry.version}
                style={{
                  marginBottom: 18,
                  paddingBottom: 14,
                  borderBottom: "1px solid rgba(255,255,255,0.12)",
                }}
              >
                <div style={{ color: "#ffe066", fontWeight: 800, marginBottom: 6 }}>
                  v{entry.version}{" "}
                  <span style={{ color: "#8ec8ff", fontWeight: 600 }}>({entry.date})</span>
                </div>
                <ul
                  style={{
                    margin: 0,
                    paddingLeft: 22,
                    color: "#d8e8fc",
                    fontWeight: 500,
                  }}
                >
                  {entry.items.map((line, i) => (
                    <li key={i} style={{ marginBottom: 6 }}>
                      {line}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div>
          <button
            style={{
              background: "linear-gradient(135deg, #ffe066 0%, #47e373 100%)",
              color: "#273b44",
              fontWeight: 900,
              border: "none",
              borderRadius: "2em",
              padding: "0.75em 2.5em",
              fontSize: "1.12em",
              cursor: "pointer",
              boxShadow: "0 4px 14px #0003, 0 1px 8px #ffe06677",
              marginTop: "4px",
            }}
            onClick={() =>
              window.history.length > 1 ? window.history.back() : (window.location.href = "/")
            }
          >
            Back
          </button>
        </div>
        <div
          style={{
            color: "#b7e4ff",
            marginTop: 36,
            fontSize: "1.08em",
            fontWeight: 700,
            opacity: 0.86,
            textShadow: "0 2px 12px #0097ff44",
          }}
        >
          by izeus, Copyright 2025
        </div>
      </div>
    </div>
  );
}
